import { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import {
  AdminToolWrapperProps,
  ErrorLayout,
  ErrorType,
  MaybeErrorData
} from '../components'
import { createContextFactory } from './utils'

interface ErrorContextData {
  errorData: MaybeErrorData
  setErrorData: (error: MaybeErrorData) => void
}

const [useErrorHandling, ErrorContextProvider] =
  createContextFactory<ErrorContextData>(
    'useErrorHandling',
    'ErrorContextProvider'
  )

const ErrorProvider = ({ children, useAdminTool }: AdminToolWrapperProps) => {
  const [errorData, setErrorData] = useState<MaybeErrorData>(undefined)

  const history = useHistory()

  useEffect(() => {
    // listen to location changes
    const unlisten = history.listen(() => {
      // clear error data on location change
      setErrorData(undefined)
    })
    // cleanup listener on unmount
    return unlisten

    /**   If you want to run an effect and clean it up only once
     * (on mount and unmount),
     * you can pass an empty array ([]) as a second argument.
     */ // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <ErrorContextProvider value={{ errorData, setErrorData }}>
      {errorData ? (
        <ErrorLayout
          showBottomBar={true}
          showTopBar={true}
          topBarSectionVisibilityProps={{
            showLangAndUser: true,
            showNavigationLinks: true,
            showUserName: errorData.errorType !== ErrorType.FETCH_USER
          }}
          errorData={errorData}
          useAdminTool={useAdminTool}
        />
      ) : (
        <>{children}</>
      )}
    </ErrorContextProvider>
  )
}

export { ErrorProvider, useErrorHandling }
